import Button from '@root/core/src/components/button';
import Card from '@root/core/src/components/card';
import Colors from '@root/brand/src/utils/colors';
import IconCell from '@root/core/src/components/icon-cell';
import LinkButton from '@root/core/src/components/link-button';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import calendar from '@root/quotes/src/assets/calendar.svg';
import dayjs from '@root/vendor/dayjs';
import stopwatchImage from '@root/quotes/src/assets/stopwatch/stopwatch.png';
import stopwatchImage2x from '@root/quotes/src/assets/stopwatch/stopwatch@2x.png';
import stopwatchImage3x from '@root/quotes/src/assets/stopwatch/stopwatch@3x.png';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function TimeDelayInfo({
  estimatedCompletionDate, onCloseModal,
}) {
  const strings = onCloseModal ? {
    heading: 'Some coverages are temporarily unavailable for purchase.',
    subtext: 'You can still move forward with a policy that doesn\'t include these changes, or feel free to check back later to see if the coverages are available.',
  } : {
    heading: 'Some of your selected coverages are temporarily unavailable for purchase.',
    subtext: 'Feel free to check back later to see if the coverages are available.',
  };

  const estimatedCompletionDateString = `${dayjs(estimatedCompletionDate).format('MM/DD/YY')}, subject to change`;

  return (
    <div css={styles.outerContainer}>
      <div css={styles.imageWrapper}>
        <img
          alt={'coverages temporarily unavailable'}
          css={styles.image}
          src={stopwatchImage}
          srcSet={`${stopwatchImage, stopwatchImage2x, stopwatchImage3x}`}
        />
      </div>
      <h1 css={styles.heading}>
        {strings.heading}
      </h1>
      <p css={styles.secondaryText}>
        {'The following coverages are currently not available for purchase:'}
      </p>
      <ul css={styles.secondaryText}>
        <li>
          {'Collision & Comprehensive'}
        </li>
        <li>
          {'Roadside Assistance'}
        </li>
        <li>
          {'Rental'}
        </li>
      </ul>
      <p css={styles.secondaryText}>
        {strings.subtext}
      </p>
      <Card cssOverrides={styles.card}>
        <IconCell
          cssOverrides={styles.completionCellContainer}
          icon={calendar}
          leftIconContainerStyles={styles.completionIconContainer}
          primaryText={'Expected coverage availability date'}
          primaryTextStyles={styles.completionPrimaryText}
          rightContainerStyles={styles.completionIconContainer}
          secondaryText={estimatedCompletionDateString}
          secondaryTextStyles={styles.completionSecondaryText}
        />
      </Card>
      {onCloseModal ? (
        <Button
          onClick={onCloseModal}
        >
          {'Got it'}
        </Button>
      ) : (
        <LinkButton
          href={'https://joinroot.com'}
          rel={'noopener noreferrer'}
        >
          {'Return to Root home'}
        </LinkButton>
      )}
    </div>
  );
}

TimeDelayInfo.propTypes = {
  estimatedCompletionDate: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func,
};

const styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    ...Theme.displayHeading3(),
  },
  secondaryText: {
    ...Theme.paragraph1(),
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 40,
  },
  image: {
    maxWidth: 300,
  },
  completionCellContainer: {
    marginBottom: 0,
  },
  completionPrimaryText: {
    ...Theme.paragraph2(),
    color: Colors.rootOrange(),
  },
  completionSecondaryText: {
    ...Theme.heading5(),
  },
  completionIconContainer: {
    borderTop: 'none',
  },
  card: {
    padding: '0px 20px',
    border: '1px solid',
    borderColor: Colors.gray20(),
    borderRadius: 8,
    ...Responsive.md({
      padding: '0px 20px',
    }),
  },
});
